// extracted by mini-css-extract-plugin
export default {"content":"dialog_content__Yhete","--mobile":"dialog_--mobile__bexy5"};